import FooterNav from "./footer-nav";
export default FooterNav;